import React from 'react'
import SearchPageRelatedPost from './searchPageRelatedPost'

const SearchPageRelatedPosts = ({ posts, centre = false }) => {
  const alignment = centre ? 'centre' : 'right'
  return (
    <section className="page-section">
      <div className="grid-container">
        <div className="search-related-posts__posts-section">
          {!centre && (
            <div className="sidebar-s -size-fixed-tablet is-hidden-phone">
              <div className="search-page-content__sidebar-spacer" />
            </div>
          )}
          <div className={`content-l -size-scale-tablet content-${alignment}`}>
            <ol className="search-related-posts__post_list">
              {posts.map((post, index) => (
                <SearchPageRelatedPost key={index} post={post} />
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SearchPageRelatedPosts
